import React from 'react';

/**
 * Catches a render crash anywhere below it so the app shows a recoverable card
 * instead of a blank white screen. It also surfaces the actual error text — so
 * when something breaks we can see *what* broke and fix that specific screen,
 * instead of guessing at a white page.
 */
export default class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Goes to the console so it's in the logs; also shown on the card below.
    console.error('[app] render crashed:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ maxWidth: 560, margin: '48px auto', padding: 24, fontFamily: 'system-ui, sans-serif', color: '#1f2937', background: '#ffffff', borderRadius: 16 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Something broke on this screen</h2>
        <p style={{ fontSize: 14, color: '#4b5563', marginBottom: 12 }}>
          The rest of the app is fine — reload to get back in. If it keeps happening on the same
          click, send this message to Claude and it'll fix that screen.
        </p>
        <pre style={{ background: '#f6f6f6', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, fontSize: 12, overflow: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {String(this.state.error?.message || this.state.error)}
        </pre>
        <button
          onClick={() => { this.setState({ error: null }); window.location.href = '/'; }}
          style={{ marginTop: 12, background: '#4f46e5', color: '#fff', border: 0, borderRadius: 8, padding: '8px 16px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
        >
          Reload the app
        </button>
      </div>
    );
  }
}
